<template>
    <div v-lazyload class="mvt-lazyload" :class="{'lazy-loading':!loaded}">
        <slot v-if="active" :lazyactive="active"></slot>
    </div>
</template>
<script src="./mvt-lazyload.js"></script>

<style lang="scss">
@use "./mvt-lazyload.scss" as *;
</style>
